// src/lib/kinema/core/effects/resolveLayer.ts
import type { BaseLayerData, Interpolator } from '../types';
import { interpolate } from './interpolate';

export type ResolvedLayer = BaseLayerData;

export function resolveLayerAtTime(
  layer: BaseLayerData,
  time: number,
  interpolators?: Map<string, Interpolator>,
): ResolvedLayer {
  const resolved = { ...layer };
  if (typeof resolved.opacity === 'number') {
    resolved.opacity = Math.max(0, Math.min(1, resolved.opacity));
  }
  const localTime = time - layer.startTime;

  for (const effect of Object.values(layer.effects)) {
    if (!effect.enabled) continue;

    // Find custom interpolator for this property
    let customLerp: ((from: any, to: any, t: number) => any) | undefined;
    if (interpolators) {
      for (const interp of interpolators.values()) {
        if (interp.properties.includes(effect.property)) {
          customLerp = interp.lerp;
          break;
        }
      }
    }

    let value = interpolate(effect.keyframes, localTime, customLerp);
    if (value !== undefined) {
      if (effect.property === 'opacity' && typeof value === 'number') {
        value = Math.max(0, Math.min(1, value));
      }
      (resolved as any)[effect.property] = value;
    }
  }

  return resolved;
}
